const _temp0 = require("inline:../../../resources/svg/arrow-down.svg");
const _temp1 = require("inline:../../../resources/svg/arrow-right.svg");
const _temp2 = require("inline:../../../resources/svg/asterisk.svg");
const _temp3 = require("inline:../../../resources/svg/bold.svg");
const _temp4 = require("inline:../../../resources/svg/bullets.svg");
const _temp5 = require("inline:../../../resources/svg/close.svg");
const _temp6 = require("inline:../../../resources/svg/dark.svg");
const _temp7 = require("inline:../../../resources/svg/download.svg");
const _temp8 = require("inline:../../../resources/svg/excel.svg");
const _temp9 = require("inline:../../../resources/svg/fetchError.svg");
const _temp10 = require("inline:../../../resources/svg/h2.svg");
const _temp11 = require("inline:../../../resources/svg/h3.svg");
const _temp12 = require("inline:../../../resources/svg/highlight.svg");
const _temp13 = require("inline:../../../resources/svg/home.svg");
const _temp14 = require("inline:../../../resources/svg/import.svg");
const _temp15 = require("inline:../../../resources/svg/inset.svg");
const _temp16 = require("inline:../../../resources/svg/italic.svg");
const _temp17 = require("inline:../../../resources/svg/jpg.svg");
const _temp18 = require("inline:../../../resources/svg/light.svg");
const _temp19 = require("inline:../../../resources/svg/list.svg");
const _temp20 = require("inline:../../../resources/svg/low-vision.svg");
const _temp21 = require("inline:../../../resources/svg/menu-dots.svg");
const _temp22 = require("inline:../../../resources/svg/menu-hr.svg");
const _temp23 = require("inline:../../../resources/svg/menu-hs.svg");
const _temp24 = require("inline:../../../resources/svg/menu-ops.svg");
const _temp25 = require("inline:../../../resources/svg/menu-td.svg");
const _temp26 = require("inline:../../../resources/svg/messages.svg");
const _temp27 = require("inline:../../../resources/svg/music.svg");
const _temp28 = require("inline:../../../resources/svg/notifications.svg");
const _temp29 = require("inline:../../../resources/svg/outset.svg");
const _temp30 = require("inline:../../../resources/svg/pdf.svg");
const _temp31 = require("inline:../../../resources/svg/piechart.svg");
const _temp32 = require("inline:../../../resources/svg/powerpoint.svg");
const _temp33 = require("inline:../../../resources/svg/printer.svg");
const _temp34 = require("inline:../../../resources/svg/profile.svg");
const _temp35 = require("inline:../../../resources/svg/question.svg");
const _temp36 = require("inline:../../../resources/svg/rolodex.svg");
const _temp37 = require("inline:../../../resources/svg/search.svg");
const _temp38 = require("inline:../../../resources/svg/tableDeleteColumn.svg");
const _temp39 = require("inline:../../../resources/svg/tableDeleteRow.svg");
const _temp40 = require("inline:../../../resources/svg/tableInsertColumn.svg");
const _temp41 = require("inline:../../../resources/svg/tableInsertRow.svg");
const _temp42 = require("inline:../../../resources/svg/text.svg");
const _temp43 = require("inline:../../../resources/svg/tick.svg");
const _temp44 = require("inline:../../../resources/svg/triangles.svg");
const _temp45 = require("inline:../../../resources/svg/undraw_access_denied_re_awnf.svg");
const _temp46 = require("inline:../../../resources/svg/undraw_dropdown_menu_re_jqqs.svg");
const _temp47 = require("inline:../../../resources/svg/undraw_empty_re_opql.svg");
const _temp48 = require("inline:../../../resources/svg/undraw_engineering_team_a7n2.svg");
const _temp49 = require("inline:../../../resources/svg/undraw_folder_files_re_2cbm.svg");
const _temp50 = require("inline:../../../resources/svg/video.svg");
const _temp51 = require("inline:../../../resources/svg/wellbeing.svg");
const _temp52 = require("inline:../../../resources/svg/word.svg");
const _temp53 = require("inline:../../../resources/svg/zip.svg");
module.exports = {
  "arrow-down.svg": _temp0,
  "arrow-right.svg": _temp1,
  "asterisk.svg": _temp2,
  "bold.svg": _temp3,
  "bullets.svg": _temp4,
  "close.svg": _temp5,
  "dark.svg": _temp6,
  "download.svg": _temp7,
  "excel.svg": _temp8,
  "fetchError.svg": _temp9,
  "h2.svg": _temp10,
  "h3.svg": _temp11,
  "highlight.svg": _temp12,
  "home.svg": _temp13,
  "import.svg": _temp14,
  "inset.svg": _temp15,
  "italic.svg": _temp16,
  "jpg.svg": _temp17,
  "light.svg": _temp18,
  "list.svg": _temp19,
  "low-vision.svg": _temp20,
  "menu-dots.svg": _temp21,
  "menu-hr.svg": _temp22,
  "menu-hs.svg": _temp23,
  "menu-ops.svg": _temp24,
  "menu-td.svg": _temp25,
  "messages.svg": _temp26,
  "music.svg": _temp27,
  "notifications.svg": _temp28,
  "outset.svg": _temp29,
  "pdf.svg": _temp30,
  "piechart.svg": _temp31,
  "powerpoint.svg": _temp32,
  "printer.svg": _temp33,
  "profile.svg": _temp34,
  "question.svg": _temp35,
  "rolodex.svg": _temp36,
  "search.svg": _temp37,
  "tableDeleteColumn.svg": _temp38,
  "tableDeleteRow.svg": _temp39,
  "tableInsertColumn.svg": _temp40,
  "tableInsertRow.svg": _temp41,
  "text.svg": _temp42,
  "tick.svg": _temp43,
  "triangles.svg": _temp44,
  "undraw_access_denied_re_awnf.svg": _temp45,
  "undraw_dropdown_menu_re_jqqs.svg": _temp46,
  "undraw_empty_re_opql.svg": _temp47,
  "undraw_engineering_team_a7n2.svg": _temp48,
  "undraw_folder_files_re_2cbm.svg": _temp49,
  "video.svg": _temp50,
  "wellbeing.svg": _temp51,
  "word.svg": _temp52,
  "zip.svg": _temp53
}